type NotFoundPageProps = {}

const NotFoundPage: React.FC<NotFoundPageProps> = () => {
  return <h1>Такой страницы еще нет</h1>
}

export default NotFoundPage
